import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_marca/comercializada';
import Comercializada from './Comercializada';


const ms2p = (state) => {
  return {
    ...state.comercial_rm,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Comercializada);
